import { api } from './client';
import type { BingDateGrain } from './bingDashboard';

export interface CriteoOverviewRow {
  date_label: string;
  clicks: number;
  spend: number;
  cpc: number;
  ctr: number;
  cpm: number;
  displays: number;
  cost_share: number;
  revenue: number;
  purchases: number;
  account_roi: number;
  aov: number;
  cpa: number;
  click_purchase_rate: number;
}

export interface CriteoOverviewResponse {
  list: CriteoOverviewRow[];
  summary: CriteoOverviewRow | null;
  region: string;
  site_code: string;
  start_date: string;
  end_date: string;
  date_grain: BingDateGrain;
}

export interface CriteoOverviewParams {
  brand_id: string;
  site_id: string;
  start_date: string;
  end_date: string;
  date_grain?: BingDateGrain;
}

interface ApiEnvelope<T> {
  code: number;
  message: string;
  data: T;
}

export const criteoDashboardApi = {
  getOverview: (params: CriteoOverviewParams) =>
    api.get<ApiEnvelope<CriteoOverviewResponse>>('/ad-dashboard/criteo/overview', { params }),
};
